import { useCallback, useEffect, useState } from "react";
import { getWaitlistStats } from "../lib/api";

// Live, data-driven waitlist progress + counter.
// - Pulls real numbers from the DB (never hardcoded).
// - The count line is only shown once total >= min_display (default 25).
// - Auto-refreshes when a new signup is submitted (listens for `heard:signup`).
export const WaitlistCounter = ({ variant = "hero" }) => {
  const [stats, setStats] = useState(null);

  const load = useCallback(() => {
    getWaitlistStats()
      .then(setStats)
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const onSignup = () => load();
    window.addEventListener("heard:signup", onSignup);
    return () => window.removeEventListener("heard:signup", onSignup);
  }, [load]);

  const total = stats?.total ?? 0;
  const goal = stats?.goal || 100;
  const visible = Boolean(stats?.visible);
  const pct = Math.min(100, Math.max(3, Math.round((total / goal) * 100)));

  if (variant === "section") {
    return (
      <div className="mt-8" data-testid="waitlist-counter-section">
        <div className="h-1.5 w-full overflow-hidden rounded-full bg-charcoal/10">
          <div
            className="h-full rounded-full bg-sage-deep transition-[width] duration-1000 ease-out"
            style={{ width: `${pct}%` }}
            data-testid="waitlist-progress-bar"
          />
        </div>
        {visible ? (
          <p className="mt-4 text-base leading-relaxed text-ink/80" data-testid="waitlist-count-text">
            <span className="font-serif text-2xl font-semibold text-sage-deep">{total}</span> people have already
            requested early access. Join our growing Founding Community.
          </p>
        ) : (
          <p className="mt-4 text-sm uppercase tracking-[0.2em] text-taupe">Founding Community forming · Launching soon</p>
        )}
      </div>
    );
  }

  // hero variant
  return (
    <div className="mt-7 max-w-sm" data-testid="waitlist-counter-hero">
      <div className="h-1 w-full overflow-hidden rounded-full bg-charcoal/12">
        <div
          className="h-full rounded-full bg-sage-deep transition-[width] duration-1000 ease-out"
          style={{ width: `${pct}%` }}
          data-testid="waitlist-progress-bar-hero"
        />
      </div>
      <p className="mt-3 text-xs uppercase tracking-[0.22em] text-ink/65" data-testid="waitlist-count-text-hero">
        {visible
          ? `${total} people have already requested early access`
          : "Launching soon · Founding community forming"}
      </p>
    </div>
  );
};
